import { createFileRoute } from "@tanstack/react-router";
import {
  Activity,
  Building2,
  Cpu,
  Database,
  FileKey,
  Monitor,
  Settings,
  PackageOpen,
  Trash,
  PieChart,
  Link as LinkIcon,
  ScrollText,
  Sparkles,
  BookOpen,
} from "lucide-react";
import { SecondaryNav } from "@client/components/secondary-nav";
import { useUiTranslation } from "@tubo/ui/i18n";

export const Route = createFileRoute("/_app/settings")({
  component: SettingsLayout,
});

// 系统设置仅超级管理员可访问（由侧栏 requireSuperAdmin 门控），不走 RBAC 权限
const settingsItems = [
  { titleKey: "teamManagement", to: "/settings/tenants" as const, icon: Building2 },
  { titleKey: "aiModels", to: "/settings/ai-models" as const, icon: Sparkles },
  { titleKey: "parser", to: "/settings/parser" as const, icon: Cpu },
  {
    titleKey: "jobCenter",
    to: "/settings/job-manager" as const,
    icon: Activity,
  },
  {
    titleKey: "quotaManagement",
    to: "/settings/quota-management" as const,
    icon: PieChart,
  },
  { titleKey: "industryPackManagement", to: "/settings/industry-packs" as const, icon: PackageOpen },
  { titleKey: "storageCleanup", to: "/settings/storage-cleanup" as const, icon: Trash },
  { titleKey: "auditLogs", to: "/settings/audit-logs" as const, icon: ScrollText },
  { titleKey: "dataConnections", to: "/settings/data-sources" as const, icon: LinkIcon },
  { titleKey: "systemStatus", to: "/settings/system-status" as const, icon: Monitor },
  { titleKey: "systemConfiguration", to: "/settings/system" as const, icon: Settings },
  { titleKey: "registrationManagement", to: "/settings/license" as const, icon: FileKey },
  { titleKey: "database", to: "/settings/database" as const, icon: Database },
  { titleKey: "helpDocs", to: "/settings/help-docs" as const, icon: BookOpen },
] as const;

function SettingsLayout() {
  const { t } = useUiTranslation("systemSettingsNavigation");
  const items = settingsItems.map(({ titleKey, ...item }) => ({
    ...item,
    title: t(titleKey),
  }));
  return <SecondaryNav title={t("title")} items={items} />;
}
